<template>
  <div class="container">
    <h1 class="title">Provision</h1>
    <h2 class="subtitle">Provisionabbrechnung</h2>
    <!-- <div class="content">
      <p class="buttons is-pulled-right">
        <b-button type="is-dark" icon-left="sync" @click="refreshData">
          Refresh
        </b-button>
      </p>
    </div> -->
    <div class="columns">
      <div class="column">
        <b-field label="Von">
          <b-datepicker
            :show-week-number="true"
            placeholder="Bitte wählen"
            icon="calendar"
            v-model="from"
            trap-focus
            @input="refreshData"
          >
          </b-datepicker>
        </b-field>
      </div>
      <div class="column">
        <b-field label="Bis">
          <b-datepicker
            :show-week-number="true"
            placeholder="Bitte wählen."
            icon="calendar"
            v-model="to"
            trap-focus
            @input="refreshData"
          >
          </b-datepicker>
        </b-field>
      </div>
      <div class="column">
        <b-field label="Exportieren">
          <b-button type="is-primary" @click="exportCsv">CSV Export</b-button>
        </b-field>
      </div>
    </div>

    <OffersTable
      :results="comission"
      @request-page="pageChange"
      :pageSize="pageSize"
      :page="page"
      :total="total"
    />
  </div>
</template>
<script>
import OffersTable from '@/components/comission/ComissionTable'
import comissionApi from '@/api/comission-api'
export default {
  name: 'Comission',
  components: {OffersTable},
  data() {
    return {
      comission: [],
      page: 1,
      pageSize: 20,
      total: 0,
      from: new Date(),
      to: new Date(),
    }
  },
  async mounted() {
    var date = new Date()
    this.from = new Date(date.getFullYear(), date.getMonth(), 1)
    this.to = new Date(date.getFullYear(), date.getMonth() + 1, 0)
    await this.refreshData()
  },
  methods: {
    async refreshData() {
      const result = await comissionApi.getComission(this.page, this.pageSize, {
        from: this.from,
        to: this.to,
      })
      this.comission = result.results
      this.page = result.page
      this.pageSize = result.pageSize
      this.total = result.total
    },
    async pageChange(page) {
      this.page = page
      await this.refreshData()
    },
    async search() {
      this.page = 1
      await this.refreshData()
    },
    async exportCsv() {
      await comissionApi.getComissionAsCsv({
        from: this.from,
        to: this.to,
      })
    },
  },
}
</script>
